<template>
  <div class="root-container">
    <div class="container">
      <div class="quiz-header">
        <div class="text-num">
          問題<span class="num">{{ currentOrder }}</span>
        </div>
        <div class="logo"><img src="public/images/logo.png" alt="" /></div>
      </div>
      <div class="question-box">
        <p v-html="quizText"></p>
        <img :src="quizImage" alt="" />
      </div>
      <div class="answer-container">
        <AnswerBox
          :id="1"
          :text="answerTexts[0]"
          :correct="answerId == 1"
          :useImage="useImage"
        ></AnswerBox>
        <AnswerBox
          :id="2"
          :text="answerTexts[1]"
          :correct="answerId == 2"
          :useImage="useImage"
        ></AnswerBox>
        <AnswerBox
          :id="3"
          :text="answerTexts[2]"
          :correct="answerId == 3"
          :useImage="useImage"
        ></AnswerBox>
      </div>
      <p class="footer-link">
        <router-link
          class="base-button button-arrow button-arrow--back button-arrow--long"
          to="/"
          v-on:click.native="tapSound()"
          >さいしょから</router-link
        >
      </p>
      <div class="illustration">
        <img src="public/images/denjiro_explanation02.png" alt="" />
      </div>
    </div>
    <Copyright />
  </div>
</template>

<script>
import AnswerBox from "./parts/AnswerBox.vue";
import QuizModel from "../scripts/QuizModel";

export default {
  name: "Quiz",
  data() {
    const order = QuizModel.getCurrentOrder();
    const quizData = QuizModel.getDataByOrder(order);
    return {
      currentOrder: order,
      quizText: quizData.qt,
      quizImage: quizData.qi,
      answerId: quizData.ca,
      answerTexts: [quizData.a1, quizData.a2, quizData.a3],
      useImage: quizData.img,
    };
  },
  components: {
    AnswerBox,
  },
};
</script>

<style scoped></style>
